import { hambergerToggle } from "./assets/js/modules/hamburgertoggle.js";
// import { initPcNav } from "./assets/js/modules/pcNav.js";
// import { spNavDropToggle } from "./assets/js/modules/spDropToggle.js";
import { scrollHint } from "./assets/js/modules/scroll-hint.js";
import { pageTopBtnAction } from "./assets/js/modules/pagetopbtn-action.js";
import { fadeInTop } from "./assets/js/modules/fadeInAni_top.js";
import { fadeInSelf } from "./assets/js/modules/fadeInAni_self.js";
import { tabAction } from "./assets/js/modules/tab.js";
// import { pageTopBtnStop } from "./assets/js/modules/pagetopbtn-stop.js";
// import { cookie } from "./assets/js/modules/cookie.js";
import { loadingAni } from "./assets/js/modules/loadding-ani.js";
// import { fadeInTop } from "./assets/js/modules/fadeInAni_top.js";
// import { fadeIn } from "./assets/js/modules/fadeInAni.js";
// import { modal } from "./assets/js/modules/modal.js";
// import { topSlider } from "./assets/js/modules/top-slider.js";
// import { accordion } from "./assets/js/modules/accordion.js";
// import { accordion02 } from "./assets/js/modules/accordion-message.js";
const $body = $("body");
// spNavDropToggle();
// initPcNav();
loadingAni();
hambergerToggle();
pageTopBtnAction();
scrollHint();
fadeInTop();
fadeInSelf();
tabAction();

// pageTopBtnStop();
// loadingAni();
// accordion();
// accordion02();
// modal();
// scrollHint();
// cookie();
// if ($body.hasClass("top")) {
//   fadeInTop();
//   topSlider();
// } else {
//   fadeIn();
// }
